import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
// import DoubleArrow from '@material-ui/icons/DoubleArrow';
// import { FormControl } from '@material-ui/core';
import { CustomLabel }  from "@tracknme/material-ui";
import { useDispatch } from 'react-redux';
import * as Actions from '../../../store/actions';



  function ModalConfirm() {

   
    const dispatch = useDispatch();
    const [openConfirm, setOpen] = useState(true);
    const [state, setState] = useState(false);


    useEffect(() => {

      if(!state ){
        setState(true)
         setTimeout(() => {
          dispatch(Actions.setLoading(false));
         }, 500);
        }
  
    }, [state,dispatch ]);
    
    const handleClose = () => {
        setOpen(false);
    };

    // function changeButtonValue(event)
    // {
    //   dispatch(Actions.setStep(2));
    // }
      
    return(

        <Modal
          id="confirm"
          disableBackdropClick={true}
          // className={classesConfirm.modalConfirm}
          style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
          }}
          disableEnforceFocus={false}
          disableEscapeKeyDown={true}
          open={openConfirm}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          
        >
          <Fade in={openConfirm}>
            <div  style={{
                backgroundColor:"#FFFFFF",
                width:400,
                height:234,
                display: 'flex',
                flexDirection:"column",
                overflow: 'hidden',
                outline:'none',
                borderRadius:10
              }}>
              <div style={{
                    backgroundColor: "#4D39E9",
                    width:400,
                    height:80,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderTopLeftRadius:10,
                    borderTopRightRadius:10
                  }}>
                <CustomLabel id="standard-basic-data-picker" label="Obrigado por se cadastrar!" color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:700, color:'#FFFFFF', marginTop:10}} />  
              </div>
              <div style={{
                          flexDirection:"row",
                          backgroundColor: "#FFFFFF",
                          width:400,
                          height:154
                        }}>

                  <div style={{marginTop:35, height:70, marginLeft:51, marginRight:51}}>
                    <CustomLabel id="standard-basic-data-picker" label="Vamos enviar um link para o seu e-mail para validar o seu cadastro." color="initial" component="h6" variant="h6" style={{fontSize:19, fontWeight:500, color:'#888888'}} />  
                  </div>
             
                  {/* <div style={{width: "100%",marginTop:5, height:40, flexDirection:"column",display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                          <CustomButton  id="button" disabled={false} onClick={() => changeButtonValue()} variant="contained" color="secondary" label="Validar" endIcon={<DoubleArrow/>}  /> 
                      </FormControl> 
                  </div> */}
              </div>
            </div>
          </Fade>
        </Modal>
  
      )
  }

  
export default ModalConfirm;